import React from "react";
import { IoCheckmarkCircle } from "react-icons/io5";
import cn from "../../lib/cn";
import { timelineBg } from "../../resources/js/images";
import P from "../../shared/typography/P";

const TimelineStepper = ({ currentStep, onClick }) => {
    return (
        <div className="  bg-linear-tag w-full p-3 xl:p-0 rounded-3xl">
            <div className="flex w-full  xl:flex-col px-3 pt-4 xl:px-5  xl:pt-5 items-start">
                <div role="button" onClick={() => onClick(1)}>
                    <P className="flex flex-col xl:flex-row items-center gap-1 text-nowrap">
                        <IoCheckmarkCircle size={20} />
                        Feasibility Survey
                    </P>
                </div>
                <hr
                    className={cn(
                        `h-0.2 w-full xl:h-[6rem] ml-1 my-1 xl:w-0.1 bg-gray-120`,
                        {
                            "bg-primary": currentStep >= 2,
                        }
                    )}
                />
                <div role="button" onClick={() => onClick(2)}>
                    <P
                        className={cn(
                            "flex flex-col xl:flex-row items-center gap-1 text-nowrap",
                            {
                                "text-gray-120": currentStep < 2,
                            }
                        )}
                    >
                        <IoCheckmarkCircle size={20} />
                        Proposal
                    </P>
                </div>
                <hr
                    className={cn(
                        `h-0.2 w-full xl:h-[6rem] ml-1 my-1 xl:w-0.1 bg-gray-120`,
                        {
                            "bg-primary": currentStep >= 3,
                        }
                    )}
                />
                <div role="button" onClick={() => onClick(3)}>
                    <P
                        className={cn(
                            "flex flex-col xl:flex-row items-center gap-1 text-nowrap",
                            {
                                "text-gray-120": currentStep < 3,
                            }
                        )}
                    >
                        <IoCheckmarkCircle size={20} />
                        Activation
                    </P>
                </div>
            </div>
            <div className="hidden  xl:flex justify-end ">
                <img src={timelineBg} width={"90%"} />
            </div>
        </div>
    );
};

export default TimelineStepper;
